
import {
  GET_PANNEL_LIST,
  UPDATE_LOADING_STATUS,
  GET_SELECT_MODAL,
  SET_MINIPROGRAM_STATUS,
  GET_MINIPROGRAM_STATUS,
  FETCH_EIBPANELLIST_LOADING,
  FETCH_EIBPANELLIST_SUCCESS,
  FETCH_EIBPANELLIST_FAILED,
} from "../actions/appPannel";

const defVal = {
  pannelList: [],
  loading: true,
  pIdDetail: {},
  isMiniProgram: false,
  miniProgramStatus: 0,
  eibPanelList: [],
  eibPanelListLoading: false,
};

export default (state = defVal, action) => {
  switch (action.type) {
    case GET_PANNEL_LIST:
      return Object.assign([], state, {
        pannelList: action.pannelList
      });

    case UPDATE_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });

    case GET_SELECT_MODAL:
      return Object.assign({}, state, {
        pIdDetail: action.pIdDetail
      });
    case SET_MINIPROGRAM_STATUS:
      return Object.assign({}, state, {
        isMiniProgram: action.isMiniProgram
      });
    case GET_MINIPROGRAM_STATUS:
      return Object.assign({}, state, {
        miniProgramStatus: action.miniProgramStatus
      });
      case FETCH_EIBPANELLIST_LOADING:
        return Object.assign({}, state, {
          eibPanelListLoading: true,
        });
      case FETCH_EIBPANELLIST_SUCCESS:
        return Object.assign({}, state, {
          eibPanelListLoading: false,
          eibPanelList: action.eibPanelList,
        });
      case FETCH_EIBPANELLIST_FAILED:
        return Object.assign({}, state, {
          eibPanelListLoading: false,
        });
    default:
      return state;
  }
};
